module.exports = __webpack_public_path__ + "assets/img/Future_Strip_en.ffc28950-ps.jpg";